import { render, staticRenderFns } from "./SearchHeader.vue?vue&type=template&id=5b3b2384&scoped=true&"
import script from "./SearchHeader.vue?vue&type=script&lang=js&"
export * from "./SearchHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchHeader.vue?vue&type=style&index=0&id=5b3b2384&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3b2384",
  null
  
)

export default component.exports